module.exports = __webpack_public_path__ + "img/title-1.50ea3b7a.png";